import {PhysicsCascade} from '../animations/PhysicsCascade';
import {ScienceScreen} from './ScienceScreen';

export const RealizationScience = () => (
  <ScienceScreen
    headline="It's physics, not failure."
    body={
      <>
        <p>
          <strong>When you sleep, the muscles around your airway relax.</strong> For some people, the soft tissue then
          partially collapses and blocks airflow.
        </p>
        <p>
          <strong>Your brain wakes you up briefly to reopen the airway.</strong> Hundreds of times a night. You don't
          notice it. You just wake up exhausted.
        </p>
      </>
    }
    animation={<PhysicsCascade />}
    callout="Weight, anatomy, and muscle tone are the main drivers. We address those — not the symptoms they cause."
    analyticsShown="GLP-1 Funnel Grief Realization Science Viewed"
    analyticsSubmitted="GLP-1 Funnel Grief Realization Science Submitted"
  />
);

export default RealizationScience;
